export default __webpack_public_path__ + "static/media/Bg-2.673c1760.png";